import { cx } from '@linaria/core';
import { useRef, useMemo, useLayoutEffect, createElement } from 'react';
import { Video23Player } from '@pm2/media-component';
import { speechSelectors, Tooltip, CrossIcon, Button } from '@ui/kit';
import { xml2ast, simpleHtmlParsers, paragraphHtmlParsers, printHtmlNodesToText, printAST, textNodeToJsxPrinter, makeHtmlNodeToJsxPrinter, generateJsxKey } from '@utils/ast';
import { typesetKatex } from '@utils/common';
import { body, wrapper, closeButton, heading, imageFigure, image, imageCaption, linkButton } from './molecule.hotspot-content.styles.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { AudioPlayer } from './molecule.audio/_audio-player.js';

function HotspotContent(props) {
  const ref = useRef(null);
  const description = useMemo(() => {
    const descriptionAST = xml2ast(`<div class="${body}">${props.hotspot.text}</div>`, {
      ...simpleHtmlParsers,
      ...paragraphHtmlParsers
    }, "text/html");
    if (!printHtmlNodesToText(descriptionAST).trim().length) {
      return undefined;
    }
    return printAST(descriptionAST, {
      text: textNodeToJsxPrinter,
      html: htmlNodeToJsxPrinter
    });
  }, [props.hotspot.text]);
  useLayoutEffect(() => {
    typesetKatex(ref);
  }, [ref]);
  return /*#__PURE__*/jsxs("section", {
    ref: ref,
    id: props.id,
    className: cx(wrapper, speechSelectors.enableSpeech.className),
    children: [props.onClose && /*#__PURE__*/jsx(Tooltip, {
      ariaType: "label",
      placement: "bottom",
      body: "Luk hotspot",
      children: ref => /*#__PURE__*/jsx("button", {
        className: closeButton,
        ref: ref,
        onClick: props.onClose,
        children: /*#__PURE__*/jsx(CrossIcon, {})
      })
    }), /*#__PURE__*/jsx("h3", {
      className: heading,
      children: props.hotspot.title
    }), /*#__PURE__*/jsx(HotspotMedia, {
      ...props
    }), description]
  });
}
function HotspotMedia(props) {
  switch (props.hotspot.media.selectedMedia) {
    case "photo":
      {
        if (!props.hotspot.media.photo) {
          return null;
        }
        return /*#__PURE__*/jsxs("figure", {
          className: imageFigure,
          children: [/*#__PURE__*/jsx("img", {
            className: image,
            src: props.hotspot.media.photo.src,
            alt: ""
          }), /*#__PURE__*/jsx("figcaption", {
            className: imageCaption,
            children: props.hotspot.media.photo.copyright
          })]
        });
      }
    case "sound":
      if (!props.hotspot.media.sound) {
        return null;
      }
      return /*#__PURE__*/jsx(AudioPlayer, {
        src: props.hotspot.media.sound?.id
      });
    case "video":
      if (!props.hotspot.media.video) {
        return null;
      }
      return /*#__PURE__*/jsx(Video23Player, {
        photoId: props.hotspot.media.video.id,
        token: "",
        aspectRatio: "56.25%",
        title: undefined,
        caption: undefined,
        showSubtitlesByDefault: false
      });
    default:
      return null;
  }
}
const htmlNodeToJsxPrinter = makeHtmlNodeToJsxPrinter({
  skipLeadingBRs: true,
  skipTrailingBRs: true,
  handleTag: (tag, data, context) => {
    if (tag !== "a") {
      return undefined;
    }
    return /*#__PURE__*/createElement(Button, {
      ...data.props,
      className: cx(data.props["className"] ? String(data.props["className"]) : undefined, linkButton),
      key: generateJsxKey(context),
      as: "a",
      theme: "primary"
    }, data.children);
  }
}, () => ({
  html: htmlNodeToJsxPrinter,
  text: textNodeToJsxPrinter
}));

export { HotspotContent };
//# sourceMappingURL=molecule.hotspot-content.js.map
